<script>
import axios from 'axios'
import XLSX from 'xlsx'
export default {
  data () {
    return {
      dataexport: [],
      modelValue: 0,
      bufferValue: 100,
      progressInterval: null,
      isLoading: false,
      dialogLoading: false,
      isImport: false,
      menu1: false,
      searchAll: {
        codeRewards: '',
        statusCode: 'all'
      },
      search: {
        statusCode: '',
        dateUse: '',
        flowId: '',
        codeRewards: ''
      },
      fileData: [],
      activeCardIndex: 0,
      currentTab: 0,
      flows: [],
      tapName: '',
      statusCounts: {
        sum_count: 0,
        used_count: 0,
        free_count: 0
      },
      statusCard: [
        {
          status: 'sum_count',
          name: 'ทั้งหมด',
          count: 0,
          isActive: true,
          icon: 'mdi-gift-outline',
          color: 'blue'
        },
        {
          status: 'used_count',
          name: 'ใช้แล้ว',
          count: 0,
          isActive: false,
          icon: 'mdi-gift-outline',
          color: 'green'
        },
        {
          status: 'free_count',
          name: 'คงเหลือ',
          count: 0,
          isActive: false,
          icon: 'mdi-clipboard-outline',
          color: 'orange'
        }
      ],
      headers: [
        { text: 'ลำดับ', value: 'no' },
        { text: 'รหัส', value: 'code_rewards' },
        { text: 'ID Card', value: 'id_card' },
        { text: 'ประเภท', value: 'type_code' },
        { text: 'จำนวน', value: 'count_limit_all' },
        { text: 'คงเหลือ', value: 'remaining_amount' },
        // { text: 'การใช้ Code', value: 'code_rewards' },
        { text: 'Status', value: 'status_code' },
        { text: 'วันที่ใช้', value: 'date_use' }
      ],
      headerImport: [
        { text: 'ลำดับ', value: 'no' },
        { text: 'รหัส', value: 'code_rewards' }
      ],
      dataCode: [],
      dataImport: [],
      statusCodeList: [
        { text: 'All', value: 'all' },
        { text: 'Free', value: 'free' },
        { text: 'Pending', value: 'pending' },
        { text: 'Used', value: 'used' }
      ],
      uploadError: {
        isError: undefined,
        message: null
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.progressInterval)
  },
  computed: {
    statusCardWithCount () {
      return this.statusCard.map(card => {
        return Object.assign({}, card, {
          count: this.statusCounts[card.status] || 0
        })
      })
    },
    filteredDataCode () {
      const keyword = this.search.codeRewards.toLowerCase()
      return this.dataCode.filter(item =>
        item.code_rewards.toLowerCase().includes(keyword)
      )
    }
  },
  async mounted () {
    this.dialogLoading = true
    this.uploadError = { isError: undefined, message: '' }
    this.isLoading = false
    this.modelValue = 0
    this.progressInterval = null
    try {
      const currentDate = new Date().toISOString().split('T')[0]
      await this.getDataflow()
      if (this.flows.length > 0) {
        this.tapName = this.flows[0].flowName
        this.search = {
          statusCode: 'all',
          dateUse: currentDate,
          flowId: this.flows[0].flowId,
          codeRewards: ''
        }
        await this.onLoadData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.dialogLoading = false
    }
  },
  methods: {
    setActive (index) {
      this.activeCardIndex = index
    },
    getRGBA (color, opacity) {
      const colors = {
        blue: '22, 177, 255',
        green: '0, 128, 0',
        orange: '255, 165, 0'
      }
      return `rgba(${colors[color] || '0, 0, 0'}, ${opacity})`
    },
    async selectFlow (itemFlow) {
      try {
        this.dialogLoading = true
        this.search.flowId = itemFlow.flowId
        this.tapName = itemFlow.flowName
        await this.onLoadData()
      } catch (error) {
        console.log(error)
      } finally {
        this.dialogLoading = false
      }
    },
    async getDataflow () {
      try {
        this.flows = []
        await axios
          .get(
            this.$DNS_IP +
            '/flow/get?shopId=' +
            this.$session.getAll().data.shopId +
            '&isShow=all'
          )
          .then(response => {
            if (response.data) {
              if (response.data.length > 0) {
                this.flows = response.data
              }
            }
          })
      } catch (error) {
        console.log(error)
      }
    },
    async onLoadData () {
      try {
        await this.getCount()
        await this.getTheMallCode()
      } catch (error) {
        console.log(error)
      }
    },
    async getCount () {
      try {
        const response = await axios.get(
          `${this.$DNS_IP}/the_mall_code/get_count?status_code=${this.search.statusCode}&date_use=${this.search.dateUse}&flowId=${this.search.flowId}`
        )
        const res = response.data
        if (res) {
          this.statusCounts = {
            sum_count: res.sum_count || 0,
            used_count: res.used_count || 0,
            free_count: res.free_count || 0
          }
        }
      } catch (error) {
        console.log('getCount', error)
      }
    },
    async getTheMallCode () {
      try {
        this.dataCode = []
        let urlGetStatusCode = `${this.$DNS_IP}/the_mall_code/get?status_code=${this.search.statusCode}&date_use=${this.search.dateUse}&flowId=${this.search.flowId}&code_rewards=${this.search.codeRewards}`
        // if (this.search.statusCode === 'free') {
        //   urlGetStatusCode = `${this.$DNS_IP}/the_mall_code/get?status_code=${this.search.statusCode}&CREATE_DATE=${this.search.dateUse}`
        // }
        await axios.get(urlGetStatusCode).then(response => {
          if (response.data) {
            if (response.data.length > 0) {
              this.dataCode = response.data
            }
          }
        })
      } catch (error) {
        console.log('getTheMallCode', error)
      }
    },
    async getCode_rewards_Count () {
      try {
        const response = await axios.get(
          `${this.$DNS_IP}/the_mall_code/get_count_code_rewards?status_code=${this.searchAll.statusCode}&code_rewards=${this.searchAll.codeRewards}`
        )
        const res = response.data
        if (res) {
          this.statusCounts = {
            sum_count: res.sum_count || 0,
            used_count: res.used_count || 0,
            free_count: res.free_count || 0
          }
        }
      } catch (error) {
        console.log('getCount', error)
      }
    },
    async getTheMall_Code_rewards () {
      if (this.searchAll.codeRewards !== '' && this.searchAll.statusCode !== '') {
        try {
          this.dataCode = []
          let urlGetStatusCode = `${this.$DNS_IP}/the_mall_code/get_code_rewards?status_code=${this.searchAll.statusCode}&code_rewards=${this.searchAll.codeRewards}`
          // if (this.search.statusCode === 'free') {
          //   urlGetStatusCode = `${this.$DNS_IP}/the_mall_code/get?status_code=${this.search.statusCode}&CREATE_DATE=${this.search.dateUse}`
          // }
          await axios.get(urlGetStatusCode).then(async (response) => {
            if (response.data) {
              if (response.data.length > 0) {
                this.dataCode = response.data
                await this.getCode_rewards_Count()
              } else {
                this.$swal({
                  title: 'ไม่พบข้อมูล',
                  text: ``,
                  type: 'info',
                  timer: 2000,
                  showConfirmButton: false
                })
              }
            } else {
              this.$swal({
                title: 'ไม่พบข้อมูล',
                text: ``,
                type: 'info',
                timer: 2000,
                showConfirmButton: false
              })
            }
          })
        } catch (error) {
          console.log('getTheMallCode', error)
        }
      } else {
        this.$swal({
          title: 'กรุณากรอกข้อมูลให้ครบ',
          text: ``,
          type: 'info',
          timer: 2000,
          showConfirmButton: false
        })
      }
    },
    async resetSearchAll () {
      this.searchAll.codeRewards = ''
      this.searchAll.statusCode = 'all'
      await this.onChangeSearch()
    },
    onImport () {
      this.isImport = true
    },
    async onChangeSearch () {
      this.dialogLoading = true
      console.log('search', this.search)

      try {
        await this.onLoadData()
      } catch (error) {
        console.log('onChangeSearch', error)
      } finally {
        this.dialogLoading = false
      }
    },
    async onStartDateInput () {
      this.menu1 = false
    },
    open () {
      // ล้างข้อมูล fileData ทั้งหมด (แบบ reactive)
      this.fileData.splice(0, this.fileData.length)

      // ถ้ามี file input element
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click() // เปิดหน้าต่างเลือกไฟล์
        this.$refs.fileInput.value = '' // รีเซ็ตค่าเพื่อให้เลือกไฟล์เดิมได้อีก
      }
    },
    handleFileUpload (event) {
      const target = event.target
      const file = target.files ? target.files[0] : null

      if (file) {
        this.fileData.push({ file })
        this.uploadFile(file)
      }

      console.log('file', file)
    },
    handleDrop (event) {
      const files = event.dataTransfer.files
      this.onDrop(files)
    },
    async onDrop (droppedFiles) {
      if (!droppedFiles || droppedFiles.length === 0) return
      this.isLoading = true
      this.modelValue = 0
      this.uploadError = { isError: undefined, message: '' }
      this.progressInterval = setInterval(() => {
        if (this.modelValue < 90) {
          this.modelValue += 1
        }
      }, 50)
      // เคลียร์ข้อมูลเก่าใน fileData
      this.fileData.splice(0, this.fileData.length)

      const file = droppedFiles[0]

      try {
        if (
          !file.name.toLowerCase().endsWith('.xlsx') &&
          !file.name.toLowerCase().endsWith('.xls')
        ) {
          this.isLoading = false
          this.modelValue = 100
          // console.log('Only .xlsx files are allowed')
          this.uploadError = {
            isError: true,
            message: 'Only .xlsx files are allowed'
          }
          return
        }
        this.fileData.push({ file })
        await this.uploadFile(file)
      } catch (error) {
        console.error('error', error)
      } finally {
        if (this.uploadError.isError) {
          clearInterval(this.progressInterval)
        }
      }
    },
    async uploadFile (file) {
      this.dataImport = []
      this.uploadError = { isError: undefined, message: '' }
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('CREATE_USER', this.$session.getAll().data.userName)

        await axios
          .post(`${this.$DNS_IP}/the_mall_code/import_excel`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            const [result, statusCode] = response.data
            if (result.status) {
              console.log('statusCode', statusCode)
              this.dataImport = result.data
              this.uploadError = {
                isError: false,
                message: ''
              }
            }
          }).catch(error => {
            console.log('uploadFile api', error.response.data.message)
            console.log('uploadFile api', error.response.data)
            console.log('uploadFile api', error.response.data.message.th)
            this.uploadError = {
              isError: true,
              message: error.response.data.message.th
              // message: error.response.data.message === 'data not found or The information already exists' ? 'ไฟล์นี้ มีข้อมูลอยู่ในระบบแล้ว' : 'การนำเข้าข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
            }
          })
      } catch (error) {
        console.log('uploadFile mai', error)
        this.uploadError = {
          isError: true,
          message: 'การนำเข้าข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง'
        }
      } finally {
        this.modelValue = 100
        clearInterval(this.progressInterval)
        this.isLoading = false
      }
    },
    getStatusText (value) {
      const status = this.statusCodeList.find(status => status.value === value)
      return status ? status.text : ''
    },
    onCancelImport () {
      this.isLoading = false
      this.isImport = false
      this.resetFile()
    },
    resetFile () {
      this.fileData = []
      this.dataImport = []
      this.modelValue = 0
      this.uploadError = { isError: undefined, message: '' }
      this.$refs.fileInput.value = null
    },
    templateExcelUnique () {
      let timeExport = [
        { flowId: this.search.flowId, code_rewards: 'xxxxxxxxxxx', type_code: 'Unique', start_date: '15/7/2025', end_date: '30/7/2025', count_limit: 1 }
      ]
      const wb = XLSX.utils.book_new() // สร้าง workbook ใหม่
      const ws = XLSX.utils.json_to_sheet(timeExport) // แปลงข้อมูลเป็น worksheet
      XLSX.utils.book_append_sheet(wb, ws, 'RewardCodes') // เพิ่ม sheet เดียว

      XLSX.writeFile(wb, 'reward_codes_unique.xlsx') // บันทึกไฟล์
    },
    templateExcelGeneric () {
      let timeExport = [
        { flowId: this.search.flowId, code_rewards: 'xxxxxxxxxxx', type_code: 'Generic', start_date: '15/7/2025', end_date: '30/7/2025', count_limit: 30 }
      ]
      const wb = XLSX.utils.book_new() // สร้าง workbook ใหม่
      const ws = XLSX.utils.json_to_sheet(timeExport) // แปลงข้อมูลเป็น worksheet
      XLSX.utils.book_append_sheet(wb, ws, 'RewardCodes') // เพิ่ม sheet เดียว

      XLSX.writeFile(wb, 'reward_codes_generic.xlsx') // บันทึกไฟล์
    },
    async onExport () {
      this.dialogLoading = true
      try {
        let dataexport = []
        for (var i = 0; i < this.dataCode.length; i++) {
          dataexport.push({
            ลำดับ: i + 1,
            รหัส: this.dataCode[i].code_rewards,
            'ID Card': this.dataCode[i].id_card,
            Status: this.getStatusText(this.dataCode[i].status_code),
            วันที่ใช้: this.format_dateNotime(this.dataCode[i].date_use)
          })
        }
        const dataWS = XLSX.utils.json_to_sheet(dataexport)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(
          wb,
          'export_code_' + this.format_dateNotime(new Date()) + '.xlsx'
        )
      } catch (error) {
        console.log('onExport', error)
      } finally {
        this.dialogLoading = false
      }
    }
  }
}
</script>
<template>
  <v-main>
    <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
      <v-row>
        <v-col cols="6" class="text-left">
          <!-- <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs> -->
        </v-col>
        <v-col cols="6" class="v-margit_button text-right"> </v-col>
      </v-row>
      <h3 class="text-left ml-4 mb-16 font-weight-bold">
        สิทธิพิเศษเฉพาะสมาชิก M Card
      </h3>
      <v-row>
        <v-col cols="12" sm="3">
          <v-tabs v-model="currentTab" vertical class="justify-start">
            <v-tab v-for="(item, index) in flows" :key="index" :value="index" class="text-left w-100"
              @click="selectFlow(item)">
              <span class="font-weight-bold text-left"
                style="white-space: normal; word-break: break-word; display: block; width: 100%;">{{ item.flowName
                }}</span>
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="12" sm="9">
          <!-- <div class="mb-4">
            <h4 class="font-weight-bold">
              {{ tapName }}
            </h4>
          </div> -->
          <v-tabs-items v-model="currentTab" style="min-height: auto; overflow: visible;">
            <v-row>
              <v-col cols="12" sm="4" v-for="(itemStatus, index) in statusCardWithCount" :key="index">
                <v-card class="pa-4" outlined :style="{
                  border: `2px solid ${getRGBA(itemStatus.color, 0.5)}`
                }">
                  <v-card-text>
                    <div class="d-flex justify-space-between">
                      <div class="d-flex flex-row align-center">
                        <div class="mr-2">
                          <v-avatar size="36" :class="`${itemStatus.color} lighten-3 white--text`">
                            <v-icon color="white">{{ itemStatus.icon }}</v-icon>
                          </v-avatar>
                        </div>
                        <div class="d-flex flex-column">
                          <div>
                            <span :class="`ml-2 font-weight-bold ${itemStatus.color}--text`
                              ">{{ itemStatus.name }}</span>
                          </div>
                          <div>
                            <span :class="`ml-2 font-weight-medium ${itemStatus.color}--text`
                              ">{{
                                itemStatus.count ? itemStatus.count : 0
                              }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="text-right mt-auto">
                        <span :class="`font-weight-bold ${itemStatus.color}--text`">รหัส</span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-4" outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" v-if="isImport">
                        <v-card flat>
                          <v-card-title>
                            <div class="d-flex justify-space-between align-center w-100">
                              <span>อัพโหลดรหัสโค้ด</span>
                              <v-btn color="primary" class=" mr-2" @click="onCancelImport()">
                                <v-icon left> {{ fileData.length > 0 && !uploadError.isError ? 'mdi-close' :
                                  'mdi-cancel' }}</v-icon>
                                {{ fileData.length > 0 && !uploadError.isError ? 'ปิดการอัพโหลด' : 'ยกเลิกการอัพโหลด'
                                }}
                              </v-btn>
                            </div>
                          </v-card-title>

                          <v-card-subtitle class="my-3">
                            เมนูหลัก / จัดการรหัสโค้ด / อัพโหลดรหัสโค้ด
                          </v-card-subtitle>
                          <v-btn small color="primary" class="mb-2" @click="templateExcelGeneric()">
                            <v-icon left>mdi-file-excel</v-icon>
                            Generic
                          </v-btn>
                          <v-btn small color="primary" class="mb-2" @click="templateExcelUnique()">
                            <v-icon left>mdi-file-excel</v-icon>
                            Unique
                          </v-btn>
                          <v-card-text>
                            <div class="flex">
                              <div class="w-full">
                                <div ref="dropZoneRef" class="cursor-pointer" @click="open" @dragover.prevent
                                  @dragenter.prevent @drop.prevent="handleDrop">
                                  <input type="file" ref="fileInput" style="display: none" accept=".xlsx, .xls"
                                    @change="handleFileUpload" />
                                  <div v-if="fileData.length === 0"
                                    class="d-flex flex-column justify-center align-center gap-y-2 pa-12 border-dashed rounded text-secondary drop-zone">
                                    <v-avatar rounded>
                                      <v-icon>mdi-upload</v-icon>
                                    </v-avatar>
                                    <h4 class="font-weight-bold">
                                      ลากและวางไฟล์ของคุณที่นี่
                                    </h4>
                                    <span class="font-weight-medium">หรือ</span>
                                    <v-btn color="info" outlined>เรียกดูไฟล์</v-btn>
                                  </div>
                                  <div v-else>
                                    <div
                                      class="d-flex flex-column justify-center align-center gap-3 pa-8 border-dashed drop-zone">
                                      <div>
                                        <v-img v-if="!uploadError.isError" :src="require('@/assets/mascot-betask-1.png')
                                          " max-height="10%" max-width="10%" contain class="mx-auto"></v-img>
                                        <v-img v-else :src="require('@/assets/mascot-betask-3.png')
                                          " max-height="10%" max-width="10%" contain class="mx-auto"></v-img>
                                      </div>

                                      <v-progress-linear v-model="modelValue" :buffer-value="bufferValue"
                                        color="primary" height="8" rounded class="mb-4" />

                                      <div v-if="uploadError.isError !== undefined">
                                        <span
                                          :class="`${uploadError.isError ? 'red--text' : 'green--text'} font-weight-medium`">{{
                                            uploadError.isError
                                              ? "การนำเข้าข้อมูลไม่สำเร็จ"
                                              : "การนำเข้าข้อมูลสำเร็จ"
                                          }}
                                        </span>
                                      </div>
                                      <div v-if="uploadError.isError">
                                        <span class="red--text font-weight-medium">{{
                                          uploadError.message
                                        }}
                                        </span>
                                      </div>
                                      <div v-if="uploadError.isError !== undefined" class="mt-3">
                                        <v-btn color="info" outlined> {{ uploadError.isError ? 'ส่งไฟล์ใหม่' :
                                          'อัพโหลดไฟล์อีกครั้ง' }}</v-btn>
                                      </div>
                                      <div class="mt-3">
                                        <span  :class="`${uploadError.isError ? 'red--text' : 'green--text'} font-weight-medium`">
                                          {{
                                            uploadError.isError
                                              ? 'เกิดข้อผิดพลาดกับไฟล์ที่อัปโหลด กรุณาเลือกไฟล์ใหม่'
                                          : 'เลือกไฟล์อื่นเพื่ออัปโหลดเพิ่มได้เลย'
                                          }}
                                        </span>
                                      </div>
                                      <div v-if="fileData.length" class="mt-3">
                                        <span class="text-wrap">
                                          <strong>ชื่อไฟล์:</strong>
                                          {{ fileData[0].file.name }}
                                        </span>
                                      </div>
                                      <div v-if="fileData.length">
                                        <span class="clamp-text text-wrap">
                                          <strong>ขนาดไฟล์:</strong>
                                          {{
                                            (
                                              fileData[0].file.size / 1024
                                            ).toFixed(2)
                                          }}
                                          KB
                                        </span>
                                      </div>
                                    </div>
                                    <div class="mt-3" v-if="dataImport.length > 0">
                                      <div>
                                        <h4 class="font-weight-bold">รหัสโค้ดเข้ามาทั้งหมด {{ dataImport.length }} code
                                        </h4>
                                      </div>
                                      <div>
                                        <v-data-table :headers="headerImport" :items="dataImport">
                                          <template v-slot:[`item.no`]="{ index }">
                                            {{ index + 1 }}
                                          </template>
                                        </v-data-table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" v-else>
                        <v-row align="center">
                          <v-col>
                            <v-text-field v-model="searchAll.codeRewards" label="ค้นหารหัส" outlined dense
                              hide-details></v-text-field>
                          </v-col>
                          <v-col>
                            <v-select :items="statusCodeList" v-model="searchAll.statusCode" item-text="text" hide-details
                              item-value="value" label="การใช้ code" dense outlined />
                          </v-col>
                          <v-col>
                            <div class="d-flex ">
                              <v-btn color="primary" class=" mr-2" @click="getTheMall_Code_rewards()">
                              <v-icon left>mdi-magnify</v-icon>
                                ค้นหาทั้งหมด
                            </v-btn>
                            <v-btn color="warning" class=" mr-2" @click="resetSearchAll()">
                              <v-icon left>mdi-refresh</v-icon>
                                reset
                            </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row align="center">
                          <v-col>
                            <v-text-field v-model="search.codeRewards" label="ค้นหารหัส จากตาราง" outlined dense
                              hide-details></v-text-field>
                          </v-col>
                          <v-col>
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="search.dateUse" label="วันที่" readonly outlined dense
                                  v-bind="attrs" v-on="on" hide-details></v-text-field>
                              </template>
                              <v-date-picker v-model="search.dateUse" @input="onStartDateInput" outlined dense
                                @change="onChangeSearch()"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col>
                            <v-select :items="statusCodeList" v-model="search.statusCode" item-text="text" hide-details
                              item-value="value" label="การใช้ code" dense outlined @change="onChangeSearch()" />
                          </v-col>

                          <v-col class="text-right">
                            <div class="d-flex flex-row w-100">
                              <div>
                                <v-btn color="primary" class=" mr-2" @click="onImport()">
                                  Import<v-icon right>mdi-arrow-collapse-down</v-icon>
                                </v-btn>
                              </div>
                              <div>
                                <v-btn color="success" outlined @click="onExport()" :disabled="dataCode.length === 0">
                                  <v-icon left>mdi-file-excel</v-icon>
                                  Export</v-btn>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                        <v-data-table :headers="headers" :items="filteredDataCode">
                          <template v-slot:[`item.no`]="{ index }">
                            {{ index + 1 }}
                          </template>
                          <template v-slot:[`item.date_use`]="{ item }">
                            {{ format_dateNotime(item.date_use) }}
                          </template>
                          <template v-slot:[`item.status_code`]="{ item }">
                            <v-chip class="ma-2" small outlined :color="item.status_code === 'used'
                                ? 'success'
                                : 'warning'
                              ">
                              {{ getStatusText(item.status_code) }}
                            </v-chip>
                          </template>
                          <template v-slot:[`item.count_limit_all`]="{ item }">
                            <div v-if="item.type_code === 'Generic'">
                              <div v-if="!item.id_card">
                                <p class="ma-0">{{ item.count_limit_all }}</p>
                              </div>
                              <div v-else>
                                <p>{{ '' }}</p>
                              </div>
                            </div>
                            <div v-else>
                              <p class="ma-0">{{ item.count_limit_all }}</p>
                            </div>
                          </template>
                          <template v-slot:[`item.remaining_amount`]="{ item }">
                            <div v-if="item.type_code === 'Generic'">
                                <div v-if="!item.id_card">
                                <p v-if="item.remaining_amount !== null && item.remaining_amount !== undefined" class="ma-0">{{ item.remaining_amount }}</p>
                                <p v-else class="ma-0">{{ item.count_limit_all }}</p>
                              </div>
                              <div v-else>
                                <p>{{ '' }}</p>
                              </div>
                            </div>
                            <div v-else>
                              <p v-if="item.status_code !== 'free'" class="ma-0">{{ '0' }}</p>
                              <p v-else class="ma-0">{{ item.count_limit_all }}</p>
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="dialogLoading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          กำลังจัดเตรียมข้อมูล กรุณารอสักครู่...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/Master/ManageCode.vue